import { DateQuestionModeType } from './types';

/**
 * Minimum allowed values for offsetHours based on date question mode.
 * Represents the minimum time offset in hours that can be configured
 * for temporal validations (after, before, between, etc.).
 */
export const MIN_OFFSET_ALLOWED_HOURS: Record<DateQuestionModeType, number> = {
  datetime: 24,
  date: 24,
  time: 1,
};

/**
 * Maximum allowed values for offsetHours based on date question mode.
 * Represents the maximum time offset in hours that can be configured
 * for temporal validations.
 * null indicates no maximum limit.
 */
export const MAX_OFFSET_ALLOWED_HOURS: Record<DateQuestionModeType, number | null> = {
  datetime: null,
  date: null,
  time: 23,
};
